/**
 * Customer-safe copy for `content.error_message` and other error-summary
 * surfaces.
 *
 * `content.error_message` historically stored the raw, untruncated
 * `str(exception)` — leaking per-article LLM cost, token usage, exception
 * class names, and raw HTTP status codes on every customer-visible surface
 * that rendered it verbatim: the Blog Command Center list
 * (ContentQueueTable), the Blog Detail page's error banner, and the
 * Activity Log tab (GenerationActivityLog's `errorMessage` prop).
 *
 * The backend now writes a sanitized value for new failures (see
 * backend/template_content_crew/orchestration/customer_safe_errors.py), but
 * rows written before that fix still have the raw text in the DB — every
 * render site imports this constant instead of rendering the raw value, so
 * those historical rows stop leaking regardless of what is stored.
 */
export const GENERATION_ERROR_MESSAGE = 'An error interrupted generation.';
